import { IconPropTypes } from '@renderer/components/Icons/IconPropTypes.ts'

const HighlightAppIcon = ({ size }: Partial<IconPropTypes>) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 5.71875C2 4.5624 2.93274 3.625 4.08333 3.625C5.23393 3.625 6.16667 4.5624 6.16667 5.71875V18.2812C6.16667 19.4376 5.23393 20.375 4.08333 20.375C2.93274 20.375 2 19.4376 2 18.2812V5.71875Z"
        fill="currentColor"
      />
      <path
        d="M17.8333 5.71875C17.8333 4.5624 18.7661 3.625 19.9167 3.625C21.0673 3.625 22 4.5624 22 5.71875V18.2812C22 19.4376 21.0673 20.375 19.9167 20.375C18.7661 20.375 17.8333 19.4376 17.8333 18.2812V5.71875Z"
        fill="currentColor"
      />
      <path
        d="M17 12C17 14.7752 14.7614 17.025 12 17.025C9.23858 17.025 7 14.7752 7 12C7 9.22477 9.23858 6.975 12 6.975C14.7614 6.975 17 9.22477 17 12Z"
        fill="currentColor"
      />
    </svg>
  )
}

const HighlightAppIconSettingsPage = ({ size }: Partial<IconPropTypes>) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 5.71875C2 4.5624 2.93274 3.625 4.08333 3.625C5.23393 3.625 6.16667 4.5624 6.16667 5.71875V18.2812C6.16667 19.4376 5.23393 20.375 4.08333 20.375C2.93274 20.375 2 19.4376 2 18.2812V5.71875Z"
        fill="white"
      />
      <path
        d="M17.8333 5.71875C17.8333 4.5624 18.7661 3.625 19.9167 3.625C21.0673 3.625 22 4.5624 22 5.71875V18.2812C22 19.4376 21.0673 20.375 19.9167 20.375C18.7661 20.375 17.8333 19.4376 17.8333 18.2812V5.71875Z"
        fill="white"
      />
      <path
        d="M17 12C17 14.7752 14.7614 17.025 12 17.025C9.23858 17.025 7 14.7752 7 12C7 9.22477 9.23858 6.975 12 6.975C14.7614 6.975 17 9.22477 17 12Z"
        fill="white"
      />
    </svg>
  )
}

const HighlightAudioIcon = ({ size }: Partial<IconPropTypes>) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8034_27574)">
        <path
          d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM6.75 14.14C6.75 14.55 6.41 14.89 6 14.89C5.59 14.89 5.25 14.55 5.25 14.14V9.86C5.25 9.45 5.59 9.11 6 9.11C6.41 9.11 6.75 9.45 6.75 9.86V14.14ZM9.75 15.57C9.75 15.98 9.41 16.32 9 16.32C8.59 16.32 8.25 15.98 8.25 15.57V8.43C8.25 8.02 8.59 7.68 9 7.68C9.41 7.68 9.75 8.02 9.75 8.43V15.57ZM12.75 17C12.75 17.41 12.41 17.75 12 17.75C11.59 17.75 11.25 17.41 11.25 17V7C11.25 6.59 11.59 6.25 12 6.25C12.41 6.25 12.75 6.59 12.75 7V17ZM15.75 15.57C15.75 15.98 15.41 16.32 15 16.32C14.59 16.32 14.25 15.98 14.25 15.57V8.43C14.25 8.02 14.59 7.68 15 7.68C15.41 7.68 15.75 8.02 15.75 8.43V15.57ZM18.75 14.14C18.75 14.55 18.41 14.89 18 14.89C17.59 14.89 17.25 14.55 17.25 14.14V9.86C17.25 9.45 17.59 9.11 18 9.11C18.41 9.11 18.75 9.45 18.75 9.86V14.14Z"
          fill="#4CEDA0"
        />
      </g>
      <defs>
        <clipPath id="clip0_8034_27574">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

const BackgroundlessAppIcon = ({ size }: Partial<IconPropTypes>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M0 4.4627C0 3.07508 1.11929 1.9502 2.5 1.9502C3.88071 1.9502 5 3.07508 5 4.4627V19.5377C5 20.9253 3.88071 22.0502 2.5 22.0502C1.11929 22.0502 0 20.9253 0 19.5377V4.4627Z"
        fill="white"
      />
      <path
        d="M19 4.4627C19 3.07508 20.1193 1.9502 21.5 1.9502C22.8807 1.9502 24 3.07508 24 4.4627V19.5377C24 20.9253 22.8807 22.0502 21.5 22.0502C20.1193 22.0502 19 20.9253 19 19.5377V4.4627Z"
        fill="white"
      />
      <path
        d="M18 12.0002C18 15.3305 15.3137 18.0302 12 18.0302C8.68629 18.0302 6 15.3305 6 12.0002C6 8.66992 8.68629 5.97019 12 5.97019C15.3137 5.97019 18 8.66992 18 12.0002Z"
        fill="white"
      />
    </svg>
  )
}

export { HighlightAppIcon, HighlightAudioIcon, HighlightAppIconSettingsPage, BackgroundlessAppIcon }
